import React from "react";
import { Link, Button, Grid, Typography } from "@material-ui/core";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  button: {
    // "& .MuiButton-textSizeSmall": {
    padding: "4px 6px",
    // },
  },
  link: {
    textDecoration: "none",
    "&:hover": {
      textDecoration: "none",
    },
  },
}));

export default function LabelWithIcon({
  startIcon,
  label,
  button,
  link,
  href,
  target,
  onClick,
}) {
  const classes = useStyles();
  return link ? (
    <Button
      size="small"
      variant="text"
      color="primary"
      component={Link}
      target={target}
      href={href}
      className={classes.link}
      onClick={onClick}
      startIcon={startIcon}
    >
      {label}
    </Button>
  ) : button ? (
    <Button
      size="small"
      variant="text"
      color="primary"
      className={classes.button}
      onClick={onClick}
      startIcon={startIcon}
    >
      {label}
    </Button>
  ) : (
    <Grid container spacing={1}>
      <Grid item>{startIcon}</Grid>
      <Grid item>
        <Typography
          variant="body1"
          color="textSecondary"
          noWrap
          style={{ maxWidth: "300px" }}
        >
          {label}
        </Typography>
      </Grid>
    </Grid>
  );
}
